// extracted by mini-css-extract-plugin
export default {"heading":"AdditionalInfo_heading__WiOFA","container":"AdditionalInfo_container__JX8OX"};